import { NgModule } from '@angular/core';
import { ResourceService } from './resource.service';
import { HubProxy, Resource } from './resource';
import { Hub } from './hub';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [
        ResourceService
    ]
})
export class HubModule {}

export * from './hub-proxies';
export {
    ResourceService,
    HubProxy,
    Hub,
    Resource
}
